export default __webpack_public_path__ + "static/media/clazzy-pic.a98df1d2.png";